import { useState } from "react";
import DetailPageDescComponent from "../../Misc/DetailPageDesc/DetailPageDescComponent";
import DetailPageTitleComponent from "../../Misc/DetailPageTitle/DetailPageTitleComponent";
import TitleLogoComponent from "../../Misc/TitleLogo/TitleLogoComponent";
import TitleTagsComponent from "../../Misc/TitleTags/TitleTagsComponent";
import DetailLearnDiscussComponent from "../DetailLearnDiscuss/DetailLearnDiscussComponent";
import "./LeftPanelComponent.scss";

const LeftPanelComponent = (props) => {
  const {
    id,
    code,
    type,
    altText,
    source,
    title,
    logoURL,
    tagsArray,
    learnData,
    description,
    isLoading,
    onLearnClick,
  } = props;

  return (
    <>
      <div className="left-panel">
        <div className="module-learn-text mt-0">
          <DetailPageTitleComponent title={title} isLoading={isLoading} />
          <div className="d-flex box-meta">
            <div className="img-box-meta">
              <TitleLogoComponent
                logoURL={logoURL}
                altText={""}
                isLoading={isLoading}
              />
            </div>
            <div className="meta-lsit">
              <TitleTagsComponent tagsArray={tagsArray} isLoading={isLoading} />
            </div>
          </div>
          <DetailPageDescComponent desc={description} isLoading={isLoading} />
          <div className="learn-discuss-section">
            <DetailLearnDiscussComponent
              id={id}
              code={code}
              type={type}
              source={source}
              showLearn={false}
              showDiscuss={true}
              isLoading={isLoading}
              learnData={learnData}
              onLearnClick={onLearnClick}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default LeftPanelComponent;
